import script from "./VehiclesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VehiclesTable.vue?vue&type=script&setup=true&lang=js"

import "./VehiclesTable.vue?vue&type=style&index=0&id=2d787184&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d787184"]])

export default __exports__